// extracted by mini-css-extract-plugin
export default {"page":"CompleteApplicantInfo_page__hcf7t","title":"CompleteApplicantInfo_title__5LmHn","copy":"CompleteApplicantInfo_copy__WVFRI","form":"CompleteApplicantInfo_form__IRvH7"};